<template>
    <v-container>
        <v-stepper v-model="step" alt-labels>
            <v-stepper-header>
                <v-stepper-step :complete="step > 1"
                                step="1">
                    Select Chart Type
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="step > 2"
                                step="2">
                    Build Chart
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-row class="mt-3 mb-3">
                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-card class="mx-auto"
                                    max-width="344"
                                    outlined>
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-4">
                                            LINE / COLUMN CHART
                                        </div>
                                        <line-chart :data="mockLineChart" type="column" height="120px" :scroll-view="false" :font-size="8"></line-chart>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-card-actions>
                                    <v-btn outlined
                                           rounded
                                           @click="onLineChartSelected"
                                           text>
                                        Select
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-card class="mx-auto"
                                    max-width="344"
                                    outlined>
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-4">
                                            WORDCLOUD
                                        </div>
                                        <word-cloud-chart :data="mockWordCloud" height="120px"></word-cloud-chart>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-card-actions>
                                    <v-btn outlined
                                           rounded
                                           @click="onWordCloudChartSelected"
                                           text>
                                        Select
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-card class="mx-auto"
                                    max-width="344"
                                    outlined>
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-4">
                                            PIE CHART
                                        </div>
                                        <pie-chart :data="mockPieChart" height="120px"></pie-chart>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-card-actions>
                                    <v-btn outlined
                                           rounded
                                           @click="onPieChartSelected"
                                           text>
                                        Select
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-card class="mx-auto"
                                    max-width="344"
                                    outlined>
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <div class="text-overline mb-4">
                                            TABLE
                                        </div>
                                        <table-chart :headers="mockTableChartHeader"
                                                     :is-search-visible="false"
                                                     :total-items="1"
                                                     :page-no="1"
                                                     :page-size="10"
                                                     :data="mockTableChart"></table-chart>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-card-actions>
                                    <v-btn outlined
                                           rounded
                                           @click="onTableChartSelected"
                                           text>
                                        Select
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>

                </v-stepper-content>

                <v-stepper-content step="2">
                    <line-chart-builder v-show="chartType==='LINE'" ref="lineChartBuilder"></line-chart-builder>
                    <word-cloud-chart-builder v-show="chartType==='WORDCLOUD'" ref="wordCloudChartBuilder"></word-cloud-chart-builder>
                    <pie-chart-builder v-show="chartType==='PIE'" ref="pieChartBuilder"></pie-chart-builder>
                    <table-chart-builder v-show="chartType==='TABLE'" ref="tableChartBuilder"></table-chart-builder>

                    <v-btn color="primary"
                           @click="onSaveChart">
                        Save
                    </v-btn>

                    <v-btn text @click="step -= 1">
                        Cancel
                    </v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-container>
</template>

<script>
    import LineChart from "../../components/charts/LineChart"
    import PieChart from "../../components/charts/PieChart"
    import TableChart from "../../components/charts/TableChart"
    import TableChartBuilder from "../../components/charts/TableChartBuilder"
    import LineChartBuilder from "../../components/charts/LineChartBuilder"
    import WordCloudChart from "../../components/charts/WordCloudChart"
    import WordCloudChartBuilder from "../../components/charts/WordCloudChartBuilder"
    import PieChartBuilder from "../../components/charts/PieChartBuilder"
    import ChartService from "../../services/chartService"
    export default {
        name: 'ChartBuilder',
        data: function () {
            return {
                isEdit: false,
                chartId: "",
                step: 1,
                mockLineChart: [],
                mockPieChart: [],
                mockTableChart: [],
                mockTableChartHeader: [],
                mockWordCloud: [{ name: "Demo", value: 3 }, { name: "Demo 2", value: 1 }, { name: "Demo 3", value: 11 }],
                chartType: "",
            }
        },
        components: {
            LineChart,
            WordCloudChart,
            WordCloudChartBuilder,
            LineChartBuilder,
            PieChart,
            PieChartBuilder,
            TableChart,
            TableChartBuilder
        },
        watch: {
            deep: true,
            immediate: true,
            chartType(val) {
                if (val == 'LINE' && this.$refs.lineChartBuilder) {
                    this.$refs.wordCloudChartBuilder.dispose();
                }
                else if (val == 'WORDCLOUD' && this.$refs.wordCloudChartBuilder) {
                    this.$refs.lineChartBuilder.dispose();
                }
                else if (val == 'PIE' && this.$refs.pieChartBuilder) {
                    this.$refs.pieChartBuilder.dispose();
                }

            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                //line chart mock
                let data = []
                let visits = 10;
                for (let i = 1; i < 15; i++) {
                    visits += Math.round(Math.random() * 10);
                    data.push({ x: new Date(2018, 0, i), value: visits });
                }

                this.mockLineChart = data;

                //pie chart mock
                let dataPie = []
                dataPie.push({ name: "Test 1", value: 3 });
                dataPie.push({ name: "Test 2", value: 12 });
                dataPie.push({ name: "Test 3", value: 7 });
                dataPie.push({ name: "Test 4", value: 2 });

                this.mockPieChart = dataPie;


                //table mock
                this.mockTableChartHeader = [];
                this.mockTableChartHeader.push({
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                });

                var mockTableChart = [];
                let test = {
                    name: "test 1234"
                }
                mockTableChart.push(test);
                this.mockTableChart = mockTableChart

                if (this.$route.params.id) {
                    this.isEdit = this.$route.params.action === "edit";
                    await this.loadSavedChart(this.$route.params.id, this.$route.params.type);
                }
            },
            async onLineChartSelected() {
                this.chartType = "LINE";
                this.step = 2;
                this.$refs.lineChartBuilder.load(null);
            },
            async onWordCloudChartSelected() {
                this.chartType = "WORDCLOUD";
                this.step = 2;
                this.$refs.wordCloudChartBuilder.load(null);
            },
            async onPieChartSelected() {
                this.chartType = "PIE";
                this.step = 2;
                this.$refs.pieChartBuilder.load(null);
            },
            async onTableChartSelected() {
                this.chartType = "TABLE";
                this.step = 2;
                this.$refs.tableChartBuilder.load(null);
            },
            async onSaveChart() {

                if (this.chartType === 'LINE') {
                    const chartDetails = this.$refs.lineChartBuilder.getChartDetails();

                    if (this.isEdit) {
                        chartDetails.id = this.chartId;
                        await ChartService.updateLineChart(chartDetails, this.accessToken);
                    }
                    else {
                        await ChartService.createLineChart(chartDetails, this.accessToken);
                    }
                }
                else if (this.chartType === 'WORDCLOUD') {
                    const chartDetails = this.$refs.wordCloudChartBuilder.getChartDetails();

                    if (this.isEdit) {
                        chartDetails.id = this.chartId;
                        await ChartService.updateWordcloudChart(chartDetails, this.accessToken);
                    }
                    else {
                        await ChartService.createWordcloudChart(chartDetails, this.accessToken);
                    }
                }
                else if (this.chartType === 'PIE') {
                    const chartDetails = this.$refs.pieChartBuilder.getChartDetails();

                    if (this.isEdit) {
                        chartDetails.id = this.chartId;
                        await ChartService.updatePieChart(chartDetails, this.accessToken);
                    }
                    else {
                        await ChartService.createPieChart(chartDetails, this.accessToken);
                    }
                }
                else if (this.chartType === 'TABLE') {
                    const chartDetails = this.$refs.tableChartBuilder.getChartDetails();

                    if (this.isEdit) {
                        chartDetails.id = this.chartId;
                        await ChartService.updateTableChart(chartDetails, this.accessToken);
                    }
                    else {
                        await ChartService.createTableChart(chartDetails, this.accessToken);
                    }
                }

            },
            async loadSavedChart(chartId, chartType) {
                this.chartType = chartType;
                this.step = 2;
                this.chartId = chartId;
            }
        },
        created() {
            this.setup();
        },
        mounted() {

        },
    }
</script>
